<ng-template ixPageHeader>
  <ix-page-title-header>
    <button
      *ixRequiresRoles="requiredRoles"
      mat-button
      ixTest="add-init-shutdown-script"
      color="primary"
      (click)="addScript()"
    >
      {{ 'Add' | translate }}
    </button>
  </ix-page-title-header>
</ng-template>

<div class="table-container">
  <ix-table2
    [ix-table2-empty]="!(dataProvider.currentPageCount$ | async)"
    [emptyConfig]="emptyService.defaultEmptyConfig(dataProvider.emptyType$ | async)"
  >
    <thead
      ix-table-head
      [columns]="columns"
      [dataProvider]="dataProvider"
    ></thead>
    <tbody
      ix-table-body
      [columns]="columns"
      [dataProvider]="dataProvider"
    >
    </tbody>
  </ix-table2>
  <ix-table-pager [dataProvider]="dataProvider"></ix-table-pager>
</div>
